import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const features = ['Shopify desde cero', 'Pasarela de pagos', 'Meta Business Suite', 'Pixel instalado', 'Primera landing', 'Primeros anuncios', 'Testeo básico', 'Mentalidad de negocio', 'Ecosistema técnico', 'Calentamiento de cuenta', 'Metodología de testeo', '100 productos validados'];
export function SystemOverview() {
  return <section className="py-12 md:py-20 relative overflow-hidden" data-id="element-261">
      <div className="absolute top-0 right-0 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-gold-500/5 rounded-full blur-[80px] md:blur-[100px] pointer-events-none" data-id="element-262" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-263">
        <div className="max-w-4xl mx-auto text-center" data-id="element-264">
          <div className="inline-block mb-4 px-3 py-1 rounded-full border border-gold-500/30 bg-gold-500/10 text-gold-400 font-bold tracking-widest text-xs uppercase" data-id="element-265">
            Sistema N°1 en Argentina
          </div>

          <h2 className="text-3xl md:text-6xl font-display text-white uppercase tracking-wide mb-3" data-id="element-266">
            Wealth Engine{' '}
            <span className="text-gold-500 block mt-1 text-base md:text-3xl tracking-widest" data-id="element-267">
              @wealthengine.ar
            </span>
          </h2>

          <p className="text-sm md:text-xl text-gray-300 mb-6 md:mb-10" data-id="element-268">
            Kit completo · 4 Etapas + 3 Bonos · Desde cero hasta tu primer
            testeo activo.
          </p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-10" data-id="element-269">
            {features.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.85
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} whileHover={{
            scale: 1.05,
            borderColor: 'rgba(212,175,55,0.5)'
          }} className="flex items-center gap-1.5 bg-dark-800 px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-white/10 text-gray-200 text-xs md:text-sm font-medium cursor-default" data-id="element-270">
                <CheckCircle2Icon className="text-gold-500 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-271" />
                {feature}
              </motion.div>)}
          </div>

          <p className="text-base md:text-2xl font-display text-white uppercase tracking-wider leading-snug" data-id="element-272">
            Funciona desde hoy. <br className="md:hidden" data-id="element-273" />
            <span className="text-gold-500" data-id="element-274">
              Desde tu casa, con tu celular o compu.
            </span>
          </p>
        </div>
      </div>
    </section>;
}